import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

/**
 * Route guard — blocks dashboard / ticket access until the user has clicked
 * the email verification link sent at signup. Renders nothing while auth is
 * loading to avoid an unwanted redirect on first paint.
 *
 * - Anonymous visitors (no role) pass through (the inner page handles auth).
 * - Logged-in but unverified users are bounced to /check-email.
 */
export default function RequireVerified({ children }) {
  const { loading, role, user, commerce } = useAuth();
  if (loading) return null;
  const subject = role === "client" ? user : role === "commerce" ? commerce : null;
  if (subject && subject.emailVerified === false) {
    return <Navigate to="/check-email" replace />;
  }
  return children;
}
